import React, { Component, PureComponent } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'

import { connect } from 'redaction'
import actions from 'redux/actions'
import { withRouter } from 'react-router-dom'
import erc20Like from 'common/erc20Like'
import { links, constants, user, stats, routing } from 'helpers'
import moment from 'moment'
import CSSModules from 'react-css-modules'
import cssModules from 'react-css-modules'
import { isMobile } from 'react-device-detect'

import metamask from 'helpers/metamask'
import Row from 'pages/History/Row/Row'
import SwapsHistory from 'pages/History/SwapsHistory/SwapsHistory'

import Table from 'components/tables/Table/Table'
import PageSeo from 'components/Seo/PageSeo'
import appConfig from 'app-config'
import { getSeoPage } from 'helpers/seo'
import { localisedUrl } from 'helpers/locale'
import config from 'app-config'
import BalanceForm from 'components/BalanceForm/BalanceForm'
import { BigNumber } from 'bignumber.js'
import ContentLoader from 'components/loaders/ContentLoader/ContentLoader'
import FilterForm from 'components/FilterForm/FilterForm'
import DashboardLayout from 'components/layout/DashboardLayout/DashboardLayout'
import ExchangeModal from 'components/modals/ExchangeModal/ExchangeModal'
import { getLocal, setLocal } from '@walletconnect/utils'
import kasaCurrencyRate from 'helpers/kasaCurrencyRate';
import wpLogoutModal from 'helpers/wpLogoutModal'
import kasaIndexPrice from 'helpers/kasaIndexPrice'

import getCurrencyKey from 'helpers/getCurrencyKey'
import lsDataCache from 'helpers/lsDataCache'
import getCoinInfo from 'common/coins/getCoinInfo'
import stylesHere from '../History/History.scss'
import styles from './CurrencyWallet.scss'
import feedback from 'helpers/feedback'

const host = window.location.hostname || document.location.host
const isWidgetBuild = config && config.isWidget

@connect(
  ({
    core,
    user,
    history: { transactions, swapHistory },
    user: {
      activeFiat,
      activeCurrency,
      isBalanceFetching,
      multisigPendingCount,
    },
  }) => ({
    user,
    activeFiat,
    hiddenCoinsList: core.hiddenCoinsList,
    txHistory: transactions,
    swapHistory,
    activeCurrency,
    isBalanceFetching,
    multisigPendingCount,
  }),
)
@withRouter
@CSSModules({ ...styles, ...stylesHere }, { allowMultiple: true })
class CurrencyWallet extends Component<any, any> {
  syncTimer: ReturnType<typeof setTimeout> | null = null
  mounted = false

  constructor(props) {
    super(props)

    const {
      match: {
        params: { ticker = null, address = null },
      },
      hiddenCoinsList,
    } = props

    const items = actions.core.getWallets({})
    const walletAddress = address

    let itemCurrency = this.filterCurrencies({
      items,
      ticker,
      walletAddress,
    })

    if (!itemCurrency.length) {
      itemCurrency = items.filter((item) => {
        if (
          (item.balance >= 0)
          && (
            (item.currency.toLowerCase() === ticker.toLowerCase())
            || (item.tokenKey && item.tokenKey.toLowerCase() === ticker.toLowerCase())
          )
        ) return true
      })
    }

    if (itemCurrency.length) {
      itemCurrency = itemCurrency[0]

      // @ts-ignore
      const { currency, address, contractAddress, decimals, balance, infoAboutCurrency } = itemCurrency
      const hasCachedData = lsDataCache.get(`TxHistory_${getCurrencyKey(currency, true).toLowerCase()}_${walletAddress}`)

      this.state = {
        itemCurrency,
        address,
        walletAddress,
        balance,
        decimals,
        currency,
        txItems: hasCachedData,
        contractAddress,
        hiddenCoinsList,
        isLoading: false,
        infoAboutCurrency,
        filterValue: walletAddress || address || '',
        ticker,
        token: erc20Like.isToken({ name: ticker }),
        isExchange: false,
      }
    }
  }

  componentDidMount() {
    this.mounted = true

    const {
      currency,
      itemCurrency,
      token,
      balance,
      infoAboutCurrency,
      hiddenCoinsList,
      ticker,
      walletAddress,
    } = this.state

    let {
      match: {
        params: {
          address = null,
          action,
        },
      },
      activeCurrency,
      activeFiat,
    } = this.props

    if (action == 'send') {
      actions.user.getBalances()
    }

    if (token && itemCurrency.standard) {
      actions[itemCurrency.standard].getBalance(currency.toLowerCase(), walletAddress).then((balance) => {
        this.setState({
          balance,
        })
      })
    } else {
      const actionName = currency.toLowerCase()

      address && actions[getCurrencyKey(actionName, false)]
        .fetchBalance(address)
        .then((balance) => this.setState({ balance }))
    }

    if (action !== 'send') {
      actions.history.setTransactions(walletAddress, ticker.toLowerCase())
    }

    if (!address) {
      actions.core.getSwapHistory()
    }

    const targetCurrency = getCurrencyKey(currency.toLowerCase(), true)
    const firstUrlPart = itemCurrency.tokenKey ? `/token/${itemCurrency.tokenKey}` : `/${targetCurrency}`
    const withdrawUrl = `${firstUrlPart}/${address}/send`
    const receiveUrl = `${firstUrlPart}/${address}/receive`

    const currentUrl = this.props.history.location.pathname.toLowerCase()

    if (currentUrl.toLowerCase() === withdrawUrl.toLowerCase() && balance !== 0) {
      actions.modals.open(constants.modals.Withdraw, {
        currency,
        address,
        balance,
        itemCurrency,
        infoAboutCurrency,
        hiddenCoinsList,
      })
      if (activeCurrency.toUpperCase() !== activeFiat) {
        actions.user.pullActiveCurrency(currency.toLowerCase())
      }
    }

    if (this.props.history.location.pathname.toLowerCase() === receiveUrl.toLowerCase()) {
      let symbol = window.widgetEvmLikeTokens.find(item => item.name == currency)?.symbol || currency;
      actions.modals.open(constants.modals.ReceiveModal, {
        currency,
        address,
        symbol,
      })
    }
  }

  componentDidUpdate(prevProps) {
    let {
      txHistory: prevTransactions,
      match: {
        params: { address: prevAddress = null },
      },
    } = prevProps

    let {
      txHistory,
      match: {
        params: { address = null, ticker = null, action = null, exchange = null },
      },
      activeCurrency,
      activeFiat,
    } = this.props;
    if (this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1] == 'exchange') {
      if (this.state.isExchange == false) {
        this.setState({ isExchange: true })
      }
    }
    const { currency } = this.state

    if (JSON.stringify(txHistory) !== JSON.stringify(prevTransactions)) {
      this.updateTransactions()
    }

    if (
      prevProps.location.pathname !== this.props.location.pathname
      || prevProps.isBalanceFetching !== this.props.isBalanceFetching
    ) {
      const items = actions.core.getWallets({})
      const walletAddress = address

      let itemCurrency = this.filterCurrencies({
        items,
        ticker,
        walletAddress,
      })

      if (!itemCurrency.length) {
        itemCurrency = items.filter((item) => {
          if (
            (item.balance >= 0)
            && (
              (item.currency.toLowerCase() === ticker.toLowerCase())
              || (item.tokenKey && item.tokenKey.toLowerCase() === ticker.toLowerCase())
            )
          ) return true
        })
      }

      if (itemCurrency.length) {
        itemCurrency = itemCurrency[0]

        const {
          currency,
          contractAddress,
          decimals,
          balance,
          infoAboutCurrency,
          tokenKey,
        } = itemCurrency
        const {
          txItems: oldTxItems,
        } = this.state

        const hasCachedData = lsDataCache.get(`TxHistory_${getCurrencyKey(currency, true).toLowerCase()}_${address}`)

        if (!this.mounted) return
        const token = erc20Like.isToken({ name: ticker })

        this.setState(
          {
            itemCurrency,
            address,
            decimals,
            currency,
            balance,
            txItems: (hasCachedData || oldTxItems),
            contractAddress,
            isLoading: false,
            infoAboutCurrency,
            filterValue: address || '',
            token,
          },
          () => {
            if (prevProps.location.pathname !== this.props.location.pathname) {
              if (activeCurrency.toUpperCase() !== activeFiat) {
                actions.user.pullActiveCurrency(currency.toLowerCase())
              }
              if (token && itemCurrency.standard) {
                actions[itemCurrency.standard].getBalance(currency.toLowerCase(), address).then((balance) => {
                  this.setState({
                    balance,
                  })
                })
              } else {
                const actionName = currency.toLowerCase()

                address && actions[getCurrencyKey(actionName, false)]
                  .fetchBalance(address)
                  .then((balance) => this.setState({ balance }))
              }

              if (action !== 'send') {
                actions.history.setTransactions(address, ticker.toLowerCase())
              }

              if (!address) {
                actions.core.getSwapHistory()
              }
            }
            const targetCurrency = getCurrencyKey(currency.toLowerCase(), true)
            const firstUrlPart = tokenKey ? `/token/${tokenKey}` : `/${targetCurrency}`
            const withdrawUrl = `${firstUrlPart}/${address}/send`
            const receiveUrl = `${firstUrlPart}/${address}/receive`
            const currentUrl = this.props.location.pathname.toLowerCase()

            if (currentUrl === withdrawUrl.toLowerCase()) {
              actions.modals.open(constants.modals.Withdraw, {
                currency,
                address,
                balance,
                infoAboutCurrency,
                itemCurrency,
              })
            }

            if (currentUrl === receiveUrl.toLowerCase()) {
              let symbol = window.widgetEvmLikeTokens.find(item => item.name == currency)?.symbol || currency;
              actions.modals.open(constants.modals.ReceiveModal, {
                currency,
                address,
                symbol,
              })
            }
          },
        )
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  filterCurrencies = (params) => {
    const { items, ticker, walletAddress } = params

    const {
      coin,
      blockchain,
    } = getCoinInfo(ticker)

    return items.filter((item) => {
      let { currency: currencyName } = item

      switch (currencyName.toLowerCase()) {
        case 'btc (multisig)':
        case 'btc (sms-protected)':
        case 'btc (pin-protected)':
          currencyName = 'btc'
      }

      const blockchainOk = (blockchain && item.blockchain)
        ? item.blockchain.toLowerCase() === blockchain.toLowerCase()
        : !(((blockchain && !item.blockchain) || (!blockchain && item.blockchain)))

      if (
        currencyName.toLowerCase() === coin.toLowerCase()
        && item.address.toLowerCase() === walletAddress.toLowerCase()
        && blockchainOk
      ) {
        return true
      }
    })
  }

  updateTransactions = () => {
    if (!this.mounted) return

    const { txHistory } = this.props
    const { currency, address } = this.state

    this.setState(() => ({
      txItems: txHistory,
    }))

    lsDataCache.push({
      key: `TxHistory_${getCurrencyKey(currency, true).toLowerCase()}_${address}`,
      data: txHistory,
      time: 3600,
    })
  }

  handleReceive = () => {
    const { currency, address } = this.state
    let symbol = window.widgetEvmLikeTokens.find(item => item.name == currency)?.symbol || currency;

    actions.modals.open(constants.modals.ReceiveModal, {
      currency,
      address,
      symbol,
    })
  }

  handleInvoice = () => {
    const { currency, address } = this.state

    actions.modals.open(constants.modals.InvoiceModal, {
      currency: currency.toUpperCase(),
      toAddress: address,
    })
  }

  handleWithdraw = () => {
    const {
      history,
      intl: { locale },
    } = this.props
    const { itemCurrency, currency, address } = this.state

    const targetCurrency = getCurrencyKey(currency.toLowerCase(), true).toLowerCase()
    const firstUrlPart = itemCurrency.tokenKey ? `/token/${itemCurrency.tokenKey}` : `/${targetCurrency}`

    history.push(localisedUrl(
      locale,
      `${firstUrlPart}/${address}/send`,
    ))
  }

  rowRender = (row, rowIndex) => {
    const {
      history,
      activeFiat,
    } = this.props

    return <Row key={rowIndex} {...row} activeFiat={activeFiat} history={history} />
  }

  handleFilterChange = ({ target }) => {
    const { value } = target

    this.setState(() => ({ filterValue: value }))
  }

  handleFilter = () => {
    const { filterValue, txItems } = this.state
    this.loading()

    if (filterValue.toLowerCase() && filterValue.length) {
      const newRows = txItems.filter(
        ({ address }) => address && address.toLowerCase().includes(filterValue.toLowerCase()),
      )

      this.setState(() => ({ txItems: newRows }))
    } else {
      this.resetFilter()
    }
  }

  loading = () => {
    this.setState(() => ({ isLoading: true }))
    setTimeout(() => this.setState(() => ({ isLoading: false })), 1000)
  }

  resetFilter = () => {
    this.loading()
    const { address, currency } = this.state
    this.setState(() => ({ filterValue: address }))
    actions.history.setTransactions(address, currency.toLowerCase())
  }

  returnFiatBalanceByWallet = (wallet) => {
    const hasFiatPrice = wallet.balance > 0 && wallet.infoAboutCurrency?.price_fiat

    if (hasFiatPrice) {
      return new BigNumber(wallet.balance)
        .multipliedBy(wallet.infoAboutCurrency.price_fiat)
        .dp(2, BigNumber.ROUND_FLOOR)
        .toNumber()
    }

    return 0
  }


  addFiatBalanceInUserCurrencyData = (currencyData) => {
    currencyData.forEach((wallet) => {
      wallet.fiatBalance = this.returnFiatBalanceByWallet(wallet)
    })

    return currencyData
  }

  returnKaxaaBalance = (currencyData) => {
    let balanceKaxaa = 0

    currencyData.forEach((wallet) => {
      if (wallet.currency === 'KAXAA') {
        balanceKaxaa = wallet.balance && wallet.balance > 0 && wallet.balance
      }
    })

    setLocal('kaxa:balance', balanceKaxaa)
    return balanceKaxaa
  }


  returnTotalFiatBalanceByCustomKaxaaAPI = (currencyData) => {
    // const allowedTokens = ['{matic}matic', '{matic}usdc', '{matic}kaxaa']
    let balance = new BigNumber(0)
    const currencyRate = getLocal('kaxa:rate') || []
    const kaxaIndexPrice = getLocal('kaxa:index')

    if (currencyData.length > 0 && currencyRate.length > 0) {
      currencyData.forEach((wallet) => {
        if (wallet.tokenKey === '{matic}kaxaa' && kaxaIndexPrice) {
          balance = balance.plus(kaxaIndexPrice * wallet.balance)
        } else {
          balance = balance.plus(wallet.fiatBalance)
          // currencyRate.forEach((item) => {
          //   if (item.coin === wallet.currency && wallet.tokenKey) {
          //     balance = balance.plus(item.rate * wallet.balance)
          //     //  console.log('wallet', wallet, 'wallet.currency', wallet.currency, 'item.rate', item.rate, 'wallet.balance', wallet.balance, 'fiat', item.rate * wallet.balance)
          //   }
          // })
        }
      })
    }

    return balance.toNumber()
  }


  syncData = () => {
    // that is for noxon, dont delete it :)
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isOneHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(1, 'hours'),
    )

    const { coinsData, coinsData: ethData } = this.props

    this.syncTimer = setTimeout(async () => {
      if (host === 'localhost' || config?.entry !== 'mainnet' || !metamask.isCorrectNetwork()) {
        return
      }

      if (isOneHourAfter || isFirstCheck) {
        localStorage.setItem(constants.localStorage.lastCheckBalance, now)
        try {
          const ipInfo = await stats.getIPInfo()

          const registrationData: {
            locale: string
            ip: string
            widget_url?: string
            wallets?: IUniversalObj[]
          } = {
            locale:
              ipInfo.locale
              || (navigator.userLanguage || navigator.language || 'en-gb').split('-')[0],
            ip: ipInfo.ip,
          }

          let widgetUrl
          if (appConfig.isWidget) {
            widgetUrl = routing.getTopLocation().origin

            registrationData.widget_url = widgetUrl
          }

          const tokensArray: any[] = Object.values(coinsData)

          const wallets = tokensArray.map((item) => ({
            symbol: item && item.currency ? item.currency.split(' ')[0] : '',
            type: item && item.currency ? item.currency.split(' ')[1] || 'common' : '',
            address: item && item.address ? item.address : '',
            balance: item && item.balance ? new BigNumber(item.balance).toNumber() : 0,
            public_key: item && item.publicKey ? item.publicKey.toString('Hex') : '',
            entry: config?.entry ? config.entry : 'testnet:undefined',
          }))

          registrationData.wallets = wallets

          await stats.updateUser(ethData.address, routing.getTopLocation().host, registrationData)
        } catch (error) {
          console.group('wallet >%c syncData', 'color: red;')
          console.error(`Sync error in wallet: ${error}`)
          console.groupEnd()
        }
      }
    }, 2000)
  }

  syncKaxaaIndexPrice = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isTenHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(10, 'hours'),
    )

    if (isTenHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckBalance, now)
      try {
        const kaxaaIndexPrice = await kasaIndexPrice.getKaxaaIndexPrice()
        setLocal('kaxa:index', kaxaaIndexPrice)
      } catch (error) {
        console.group('wallet >%c index price kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa index price: ${error}`)
        console.groupEnd()
      }
    }
  }

  syncKaxaaCurrencyRate = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckCurrencyRate) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isSixHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(6, 'hours'),
    )

    if (isSixHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckCurrencyRate, now)
      try {
        const kaxaaCurrencyRate = await kasaCurrencyRate.kasaCurrencyRate()
        setLocal('kaxa:rate', kaxaaCurrencyRate)
      } catch (error) {
        console.group('wallet >%c currency rate kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa currency rate: ${error}`)
        console.groupEnd()
      }
    }
  }


  render() {
    let {
      swapHistory,
      txHistory,
      location,
      match: {
        params: { address = null },
      },
      intl,
      hiddenCoinsList,
      isBalanceFetching,
      activeFiat,
      activeCurrency,
      multisigPendingCount,
    } = this.props

    const {
      currency,
      itemCurrency,
      itemCurrency: {
        isToken,
        tokenKey,
      },
      balance,
      infoAboutCurrency,
      txItems,
      filterValue,
      isLoading,
      isExchange,
    } = this.state

    let currencyName = currency.toLowerCase()
    let currencyViewName = (isToken) ? currency.replaceAll(`*`, ``).toLowerCase() : currency.toLowerCase()

    switch (currencyName) {
      case 'btc (multisig)':
      case 'btc (sms-protected)':
      case 'btc (pin-protected)':
        currencyName = 'btc'
    }

    txHistory = txItems || txHistory

    if (txHistory) {

      txHistory = txHistory.filter((tx) => {
        if (tx?.type) {
          return (isToken) ? (tx.tokenKey === tokenKey) : (tx.type.toLowerCase() === currencyName)
        }
        return false
      })
    }

    const showSwapHistory = (address?.toLowerCase() === itemCurrency.address.toLowerCase())

    if (showSwapHistory) {
      swapHistory = Object.keys(swapHistory)
        .map((key) => swapHistory[key])
        .filter((swap) => swap.sellCurrency === currency || swap.buyCurrency === currency)
        .reverse()
    }

    const seoPage = getSeoPage(location.pathname)

    const titleSwapOnline = defineMessages({
      metaTitle: {
        id: 'CurrencyWalletTitle',
        defaultMessage: 'Swap.Online - {fullName} ({currency}) Web Wallet with Atomic Swap.',
      },
    })
    const titleWidgetBuild = defineMessages({
      metaTitle: {
        id: 'CurrencyWalletWidgetBuildTitle',
        defaultMessage: '{fullName} ({currency}) Web Wallet with Atomic Swap.',
      },
    })
    const title = isWidgetBuild ? titleWidgetBuild : titleSwapOnline

    const description = defineMessages({
      metaDescription: {
        id: 'CurrencyWallet154',
        defaultMessage:
          'Atomic Swap Wallet allows you to manage and securely exchange ${fullName} (${currency}) with 0% fees. Based on Multi-Sig and Atomic Swap technologies.',
      },
    })

    if (hiddenCoinsList.includes(currency)) {
      actions.core.markCoinAsVisible(currency)
    }

    if (!config.isWidget || window?.STATISTICS_ENABLED) {
      this.syncData()
    }

    this.syncKaxaaIndexPrice()
    this.syncKaxaaCurrencyRate()



    const allWallets = actions.core.getWallets({})
    let userWallets = user.filterUserCurrencyData(allWallets)

    userWallets = this.addFiatBalanceInUserCurrencyData(userWallets)

    // save KAXAA balance in localstorage to use in GetKax page
    this.returnKaxaaBalance(userWallets)

    // const balanceInBtc = this.returnTotalBalanceInBtc(userWallets) // TODO:: for now not showing collective btc balance
    // const allFiatBalance = this.returnTotalFiatBalance(userWallets) // TODO:: need to check USD aka Fiat balance calculation
    const allFiatBalanceByKaxaaCurrencyRateApi = this.returnTotalFiatBalanceByCustomKaxaaAPI(userWallets) // kaxa:balance

    const kaxaaIndex = getLocal('kaxa:index')
    let totalCurrencyBalanceInKaxaa = 0
    if (kaxaaIndex) {
      totalCurrencyBalanceInKaxaa = allFiatBalanceByKaxaaCurrencyRateApi / kaxaaIndex
    }

    return (
      <div styleName="root">
        <PageSeo
          location={location}
          defaultTitle={intl.formatMessage(title.metaTitle, {
            fullName: currency,
            currency,
          })}
          defaultDescription={intl.formatMessage(description.metaDescription, {
            fullName: currency,
            currency,
          })}
        />
        {this.state.isExchange && (
          <div>
            <ExchangeModal />
          </div>
        )}
        <div styleName="currencyWalletActivity">
          <FilterForm
            filterValue={filterValue}
            onSubmit={this.handleFilter}
            onChange={this.handleFilterChange}
            resetFilter={this.resetFilter}
          />
          {txHistory
            && !isLoading
            && !isExchange
            && (txHistory.length > 0 ? (
              // TODO: use the infinite list component or smth else
              // if we have lots of tx with the Table then it
              // load long time and display all transaction
              <Table rows={txHistory} styleName="currencyHistory" rowRender={this.rowRender} />
            ) : (
              <div styleName="historyContent">
                <ContentLoader rideSideContent empty nonHeader inner />
              </div>
            ))}
          {(!txHistory || isLoading) &&
            !isExchange &&
            (
              <div styleName="historyContent">
                <ContentLoader rideSideContent nonHeader />
              </div>
            )}
        </div>
        {showSwapHistory && (
          <>
            {!actions.btcmultisig.isBTCMSUserAddress(`${address}`)
              && (swapHistory.filter((item) => item.step >= 1).length > 0 ? (
                <SwapsHistory orders={swapHistory.filter((item) => item.step >= 4)} />
              ) : (
                ''
              )
              )}
          </>
        )}
        {seoPage && seoPage.footer && <div>{seoPage.footer}</div>}
      </div>
    )
  }
}

@connect(
  ({
    core: { hiddenCoinsList },
    user: {
      activeFiat,
      ethData,
      bnbData,
      maticData,
      arbethData,
      aurethData,
      xdaiData,
      ftmData,
      movrData,
      oneData,
      ameData,
      avaxData,
      btcData,
      ghostData,
      nextData,
      phiData,
      tokensData,
      btcMultisigSMSData,
      btcMultisigUserData,
      btcMultisigUserDataList,
      isBalanceFetching,
      multisigPendingCount,
      activeCurrency,
      metamaskData,
    },
    currencies: { items: currencies },
    modals,
  }) => {
    const userCurrencyData = [
      ethData,
      bnbData,
      maticData,
      arbethData,
      aurethData,
      xdaiData,
      ftmData,
      avaxData,
      movrData,
      oneData,
      ameData,
      btcData,
      ghostData,
      nextData,
      phiData,
      ...Object.keys(tokensData).map((k) => tokensData[k]),
    ]

    return {
      userCurrencyData,
      currencies,
      isBalanceFetching,
      multisigPendingCount,
      hiddenCoinsList,
      user,
      activeCurrency,
      activeFiat,
      coinsData: {
        ethData,
        bnbData,
        maticData,
        arbethData,
        aurethData,
        xdaiData,
        ftmData,
        avaxData,
        movrData,
        oneData,
        ameData,
        phiData,
        metamaskData: {
          ...metamaskData,
          currency: 'ETH Metamask',
        },
        btcData,
        ghostData,
        nextData,
        btcMultisigSMSData,
        btcMultisigUserData,
        btcMultisigUserDataList,
      },
      modals,
    }
  },
)
@withRouter
@cssModules(styles, { allowMultiple: true }) @cssModules(styles, { allowMultiple: true })
class CurrencyWalletPage extends PureComponent<any, any> {
  syncTimer: ReturnType<typeof setTimeout> | null = null

  constructor(props) {
    super(props)

    const {
      match: {
        params: { page = null },
      },
      multisigPendingCount,
    } = props

    let activeComponentNum = 0

    if (page === 'history' && !isMobile) {
      activeComponentNum = 1
    }
    if (page === 'invoices') {
      // activeComponentNum = 2
      activeComponentNum = 1
    }

    this.state = {
      activeComponentNum,
      btcBalance: 0,
      enabledCurrencies: user.getActivatedCurrencies(),
      multisigPendingCount,
    }
  }

  handleConnectWallet() {
    const {
      history,
      intl: { locale },
    } = this.props

    if (metamask.isConnected()) {
      history.push(localisedUrl(locale, links.home))
      return
    }

    setTimeout(() => {
      metamask.connect({})
    }, 100)
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { page: prevPage = null },
      },
      multisigPendingCount: prevMultisigPendingCount,
      location: { pathname: prevPathname },
    } = prevProps

    const {
      match: {
        params: { page = null },
      },
      multisigPendingCount,
      intl,
      intl: { locale },
      location: { pathname },
      history,
    } = this.props

    if (
      pathname.toLowerCase() !== prevPathname.toLowerCase()
      && pathname.toLowerCase() === links.connectWallet.toLowerCase()
    ) {
      this.handleConnectWallet()
    }

    if (page !== prevPage || multisigPendingCount !== prevMultisigPendingCount) {
      let activeComponentNum = 0

      if (page === 'history' && !isMobile) activeComponentNum = 1
      // if (page === 'invoices') activeComponentNum = 2
      if (page === 'invoices') activeComponentNum = 1

      if (page === 'exit') {
        wpLogoutModal(() => {
          history.push(localisedUrl(locale, links.home))
        }, intl)
      }

      this.setState(() => ({
        activeComponentNum,
        multisigPendingCount,
      }))
    }
    // @ts-ignore
    clearTimeout(this.syncTimer)
  }

  componentDidMount() {
    const {
      match: {
        params,
        params: { page },
        url,
      },
      multisigPendingCount,
      history,
      location: { pathname },
      intl,
      intl: { locale },
    } = this.props

    if (pathname.toLowerCase() === links.connectWallet.toLowerCase()) {
      this.handleConnectWallet()
    }

    actions.user.getBalances()

    // actions.user.fetchMultisigStatus()

    if (url.includes('send')) {
      this.handleWithdraw(params)
    }

    if (page === 'exit') {
      wpLogoutModal(() => {
        history.push(localisedUrl(locale, links.home))
      }, intl)
    }
    this.getInfoAboutCurrency()
    this.setState({
      multisigPendingCount,
    })
  }

  getInfoAboutCurrency = async () => {
    const { currencies } = this.props
    const currencyNames = currencies.map(({ value, name }) => value || name)

    await actions.user.getInfoAboutCurrency(currencyNames)
  }

  handleWithdraw = (params) => {
    let { userCurrencyData } = this.state
    const { address, amount } = params
    if (!userCurrencyData) {
      userCurrencyData = actions.core.getWallets({});
    }
    let item = {};
    if (params.currency) {
      item = userCurrencyData.find(
        ({ currency }) => currency.toLowerCase() === params.currency.toLowerCase(),
      )
    } else {
      item = userCurrencyData.find(
        ({ currency }) => currency.toLowerCase() === params.ticker.toLowerCase(),
      )
    }


    actions.modals.open(constants.modals.Withdraw, {
      ...item,
      address,
      amount,
    })
  }

  goToСreateWallet = () => {
    feedback.wallet.pressedAddCurrency()
    const {
      history,
      intl: { locale },
    } = this.props

    history.push(localisedUrl(locale, links.createWallet))
  }

  handleReceive = (context) => {
    const widgetCurrencies = user.getWidgetCurrencies()
    const filteredCurrencies = user.filterUserCurrencyData(actions.core.getWallets())

    const availableWallets = filteredCurrencies.filter((item) => {
      const { isMetamask, isConnected, currency, balance } = item

      return (
        (context !== 'Send' || balance)
        && (!isMetamask || (isMetamask && isConnected))
        && (!isWidgetBuild || widgetCurrencies.includes(currency))
      )
    })

    actions.modals.open(constants.modals.CurrencyAction, {
      currencies: availableWallets,
      context,
    })
  }

  showNoWalletsNotification = () => {
    actions.notifications.show(
      constants.notifications.Message,
      {
        message: (
          <FormattedMessage
            id="WalletEmptyBalance"
            defaultMessage="No wallets available"
          />
        ),
      },
    )
  }

  handleWithdrawFirstAsset = () => {
    const {
      history,
      intl: { locale },
    } = this.props
    const userCurrencyData = actions.core.getWallets({})
    const availableWallets = user.filterUserCurrencyData(userCurrencyData)

    if (
      !Object.keys(availableWallets).length
      || (Object.keys(availableWallets).length === 1 && !user.isCorrectWalletToShow(availableWallets[0]))
    ) {
      this.showNoWalletsNotification()
      return
    }

    const firstAvailableWallet = availableWallets.find((wallet) => wallet.currency.toLowerCase() === 'kaxaa')

    // const firstAvailableWallet = availableWallets.find((wallet) => (
    //   user.isCorrectWalletToShow(wallet)
    //   && !wallet.balanceError
    //   && new BigNumber(wallet.balance).isPositive()
    // ))

    if (!firstAvailableWallet) {
      this.showNoWalletsNotification()
      return
    }

    const { currency, address, tokenKey } = firstAvailableWallet
    let targetCurrency = currency

    switch (currency.toLowerCase()) {
      case 'btc (multisig)':
      case 'btc (sms-protected)':
      case 'btc (pin-protected)':
        targetCurrency = 'btc'
    }

    const firstUrlPart = tokenKey ? `/token/${tokenKey}` : `/${targetCurrency}`

    history.push(
      localisedUrl(locale, `${firstUrlPart}/${address}/send`),
    )
  }

  returnFiatBalanceByWallet = (wallet) => {
    const hasFiatPrice = wallet.balance > 0 && wallet.infoAboutCurrency?.price_fiat

    if (hasFiatPrice) {
      return new BigNumber(wallet.balance)
        .multipliedBy(wallet.infoAboutCurrency.price_fiat)
        .dp(2, BigNumber.ROUND_FLOOR)
        .toNumber()
    }

    return 0
  }

  addFiatBalanceInUserCurrencyData = (currencyData) => {
    currencyData.forEach((wallet) => {
      wallet.fiatBalance = this.returnFiatBalanceByWallet(wallet)
    })

    return currencyData
  }

  returnBalanceInBtc = (wallet) => {
    const widgetCurrencies = user.getWidgetCurrencies()
    const name = wallet.isToken
      ? wallet.tokenKey.toUpperCase()
      : (wallet.currency || wallet.name)

    if (
      (!isWidgetBuild || widgetCurrencies.includes(name))
      && !wallet.balanceError
      && wallet.infoAboutCurrency?.price_btc
      && wallet.balance > 0
    ) {
      return wallet.balance * wallet.infoAboutCurrency.price_btc
    }

    return 0
  }

  returnTotalBalanceInBtc = (currencyData) => {
    let balance = new BigNumber(0)

    currencyData.forEach((wallet) => {
      balance = balance.plus(this.returnBalanceInBtc(wallet))
    })

    return balance.toNumber()
  }

  returnKaxaaBalance = (currencyData) => {
    let balanceKaxaa = 0

    currencyData.forEach((wallet) => {
      if (wallet.currency === 'KAXAA') {
        balanceKaxaa = wallet.balance && wallet.balance > 0 && wallet.balance
      }
    })

    setLocal('kaxa:balance', balanceKaxaa)
    return balanceKaxaa
  }

  returnTotalFiatBalanceByCustomKaxaaAPI = (currencyData) => {
    // const allowedTokens = ['{matic}matic', '{matic}usdc', '{matic}kaxaa']
    let balance = new BigNumber(0)
    const currencyRate = getLocal('kaxa:rate') || []
    const kaxaIndexPrice = getLocal('kaxa:index')

    if (currencyData.length > 0 && currencyRate.length > 0) {
      currencyData.forEach((wallet) => {
        if (wallet.tokenKey === '{matic}kaxaa' && kaxaIndexPrice) {
          balance = balance.plus(kaxaIndexPrice * wallet.balance)
        } else {
          balance = balance.plus(wallet.fiatBalance)
          // currencyRate.forEach((item) => {
          //   if (item.coin === wallet.currency && wallet.tokenKey) {
          //     balance = balance.plus(item.rate * wallet.balance)
          //     //  console.log('wallet', wallet, 'wallet.currency', wallet.currency, 'item.rate', item.rate, 'wallet.balance', wallet.balance, 'fiat', item.rate * wallet.balance)
          //   }
          // })
        }
      })
    }

    return balance.toNumber()
  }

  returnTotalFiatBalance = (currencyData) => {
    let balance = new BigNumber(0)

    currencyData.forEach((wallet) => {
      balance = balance.plus(wallet.fiatBalance)
    })

    return balance.toNumber()
  }

  syncData = () => {
    // that is for noxon, dont delete it :)
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isOneHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(1, 'hours'),
    )

    const { coinsData, coinsData: ethData } = this.props

    this.syncTimer = setTimeout(async () => {
      if (host === 'localhost' || config?.entry !== 'mainnet' || !metamask.isCorrectNetwork()) {
        return
      }

      if (isOneHourAfter || isFirstCheck) {
        localStorage.setItem(constants.localStorage.lastCheckBalance, now)
        try {
          const ipInfo = await stats.getIPInfo()

          const registrationData: {
            locale: string
            ip: string
            widget_url?: string
            wallets?: IUniversalObj[]
          } = {
            locale:
              ipInfo.locale
              || (navigator.userLanguage || navigator.language || 'en-gb').split('-')[0],
            ip: ipInfo.ip,
          }

          let widgetUrl
          if (appConfig.isWidget) {
            widgetUrl = routing.getTopLocation().origin

            registrationData.widget_url = widgetUrl
          }

          const tokensArray: any[] = Object.values(coinsData)

          const wallets = tokensArray.map((item) => ({
            symbol: item && item.currency ? item.currency.split(' ')[0] : '',
            type: item && item.currency ? item.currency.split(' ')[1] || 'common' : '',
            address: item && item.address ? item.address : '',
            balance: item && item.balance ? new BigNumber(item.balance).toNumber() : 0,
            public_key: item && item.publicKey ? item.publicKey.toString('Hex') : '',
            entry: config?.entry ? config.entry : 'testnet:undefined',
          }))

          registrationData.wallets = wallets

          await stats.updateUser(ethData.address, routing.getTopLocation().host, registrationData)
        } catch (error) {
          console.group('wallet >%c syncData', 'color: red;')
          console.error(`Sync error in wallet: ${error}`)
          console.groupEnd()
        }
      }
    }, 2000)
  }

  syncKaxaaIndexPrice = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isTenHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(10, 'hours'),
    )

    if (isTenHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckBalance, now)
      try {
        const kaxaaIndexPrice = await kasaIndexPrice.getKaxaaIndexPrice()
        setLocal('kaxa:index', kaxaaIndexPrice)
      } catch (error) {
        console.group('wallet >%c index price kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa index price: ${error}`)
        console.groupEnd()
      }
    }
  }

  syncKaxaaCurrencyRate = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckCurrencyRate) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isSixHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(6, 'hours'),
    )

    if (isSixHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckCurrencyRate, now)
      try {
        const kaxaaCurrencyRate = await kasaCurrencyRate.kasaCurrencyRate()
        setLocal('kaxa:rate', kaxaaCurrencyRate)
      } catch (error) {
        console.group('wallet >%c currency rate kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa currency rate: ${error}`)
        console.groupEnd()
      }
    }
  }

  render() {
    const {
      activeComponentNum,
      multisigPendingCount,
    } = this.state

    const {
      hiddenCoinsList,
      isBalanceFetching,
      activeFiat,
      activeCurrency,
      match: {
        params: { page = null },
      },
    } = this.props

    if (!config.isWidget || window?.STATISTICS_ENABLED) {
      this.syncData()
    }

    this.syncKaxaaIndexPrice()
    this.syncKaxaaCurrencyRate()

    const allWallets = actions.core.getWallets({})
    let userWallets = user.filterUserCurrencyData(allWallets)

    userWallets = this.addFiatBalanceInUserCurrencyData(userWallets)

    // save KAXAA balance in localstorage to use in GetKax page
    this.returnKaxaaBalance(userWallets)

    // const balanceInBtc = this.returnTotalBalanceInBtc(userWallets) // TODO:: for now not showing collective btc balance
    // const allFiatBalance = this.returnTotalFiatBalance(userWallets) // TODO:: need to check USD aka Fiat balance calculation
    const allFiatBalanceByKaxaaCurrencyRateApi = this.returnTotalFiatBalanceByCustomKaxaaAPI(userWallets) // kaxa:balance

    const kaxaaIndex = getLocal('kaxa:index')
    let totalCurrencyBalanceInKaxaa = 0
    if (kaxaaIndex) {
      totalCurrencyBalanceInKaxaa = allFiatBalanceByKaxaaCurrencyRateApi / kaxaaIndex
    }
    // const allFiatBalance = kaxaaIndex * kaxaaBalance // kaxaaBalanceInUSD // only for kaxaa

    return (
      <DashboardLayout
        page={page}
        BalanceForm={(
          <BalanceForm
            activeFiat={activeFiat}
            fiatBalance={allFiatBalanceByKaxaaCurrencyRateApi}
            currencyBalance={totalCurrencyBalanceInKaxaa}
            activeCurrency={activeCurrency}
            handleReceive={this.handleReceive}
            handleWithdraw={this.handleWithdrawFirstAsset}
            isFetching={isBalanceFetching}
            type="wallet"
            currency="kax"
            multisigPendingCount={multisigPendingCount}
            activeComponentNum={activeComponentNum}
          />
        )}
      >

        <CurrencyWallet {...this.props} />
      </DashboardLayout>
    )
  }
}

export default injectIntl(CurrencyWalletPage)
